import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Link } from '@superops/ui-design-system';
import React from 'react';

function LinkCell(props) {
  const { cell, action } = props;
  const actions = cell?.column?.actions;
  // <Link {...cell.column.actions}>
  return cell.value ? (
    <Link removeUnderline onClick={actions?.onClick?.bind(this, cell)}>
      {cell.value}
    </Link>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default LinkCell;
